(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const TS = window.TS || {};
  const rtl = document.documentElement.dir === 'rtl';

  /* ---------- toast ---------- */
  let toastEl, toastT;
  const toast = (msg) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2200);
  };

  /* ---------- drawers ---------- */
  let lastFocus = null;
  const openDrawer = (name) => {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return false;
    if (d.classList.contains('is-open')) return true;
    $$('[data-drawer].is-open').forEach(closeDrawer);
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.classList.add('lock');
    const f = $('input[type=search]', d) || $('[data-close].icon-btn', d);
    setTimeout(() => f && f.focus({ preventScroll: true }), 60);
    return true;
  };
  const closeDrawer = (d) => {
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('lock');
    setTimeout(() => { d.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { if (openDrawer(o.dataset.open)) e.preventDefault(); return; }
    const c = e.target.closest('[data-close]');
    if (c) closeDrawer(c.closest('[data-drawer]'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('[data-drawer].is-open').forEach(closeDrawer); });

  /* ---------- cart ---------- */
  const sectionsParam = 'cart-drawer';
  const renderCart = (sections) => {
    if (!sections || !sections['cart-drawer']) return;
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = $('[data-drawer="cart"] .drawer__panel', html);
    const cur = $('[data-drawer="cart"] .drawer__panel');
    if (fresh && cur) cur.replaceWith(fresh);
  };
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((b) => { b.textContent = count; b.classList.toggle('is-empty', !count); b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
  };
  const refreshCount = () => fetch(TS.root.replace(/\/$/, '') + '/cart.js').then((r) => r.json()).then((c) => updateCount(c.item_count)).catch(() => {});

  const addToCart = async (form, opts = {}) => {
    const fd = new FormData(form);
    fd.append('sections', sectionsParam);
    fd.append('sections_url', window.location.pathname);
    const btn = opts.btn || $('[type=submit]', form);
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(TS.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || TS.t.error);
      if (opts.checkout) { window.location.href = (TS.root.replace(/\/$/, '')) + '/checkout'; return; }
      renderCart(data.sections);
      await refreshCount();
      openDrawer('cart');
      if (btn) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1400); }
    } catch (err) {
      toast(err.message || TS.t.error);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add]');
    if (!form) return;
    e.preventDefault();
    const isBuy = e.submitter && e.submitter.hasAttribute('data-buy-now');
    addToCart(form, { btn: e.submitter, checkout: isBuy });
  });

  const changeLine = async (line, quantity) => {
    const panel = $('[data-drawer="cart"] .drawer__panel');
    panel && panel.classList.add('is-busy');
    try {
      const res = await fetch(TS.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: sectionsParam, sections_url: window.location.pathname }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || TS.t.error);
      renderCart(data.sections);
      updateCount(data.item_count);
    } catch (err) { toast(err.message); }
  };
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-drawer="cart"] [data-qty]');
    if (!q) return;
    const li = q.closest('[data-line]');
    changeLine(+li.dataset.line, Math.max(0, +q.dataset.qty));
  });

  /* ---------- sliders (scroll-snap) ---------- */
  $$('[data-slider]').forEach((root) => {
    const track = $('[data-track]', root);
    if (!track) return;
    const slides = [...track.children].filter((el) => el.getClientRects().length);
    if (!slides.length) return;
    let dotsWrap = $('[data-dots]', root);
    if (dotsWrap && !dotsWrap.children.length && slides.length > 1) {
      // build dots for sliders that render empty dot containers
      const per = () => Math.max(1, Math.round(track.clientWidth / (slides[0].getBoundingClientRect().width || 1)));
      const pages = Math.ceil(slides.length / per());
      for (let i = 0; i < pages && pages > 1; i++) { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', i + 1); dotsWrap.appendChild(b); }
    }
    const dots = dotsWrap ? [...dotsWrap.children] : [];
    const thumbs = $$('[data-goto]', root);
    const pos = () => Math.abs(track.scrollLeft);
    const step = () => slides[0].offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const index = () => Math.round(pos() / step());
    const goTo = (i) => { const x = i * step(); track.scrollTo({ left: rtl ? -x : x, behavior: 'smooth' }); };
    let raf;
    const sync = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = index();
        const maxScroll = track.scrollWidth - track.clientWidth;
        const dotI = dots.length && slides.length !== dots.length ? Math.min(dots.length - 1, Math.round((pos() / (maxScroll || 1)) * (dots.length - 1))) : i;
        dots.forEach((d, k) => d.classList.toggle('is-on', k === dotI));
        thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
        if (!root.hasAttribute('data-cards')) slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      });
    };
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => {
      if (slides.length === dots.length) return goTo(k);
      const maxScroll = track.scrollWidth - track.clientWidth;
      const x = (maxScroll * k) / Math.max(1, dots.length - 1);
      track.scrollTo({ left: rtl ? -x : x, behavior: 'smooth' });
    }));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(+t.dataset.goto)));
    sync();
    if (root.dataset.autoplay === 'true' && slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer, paused = false, visible = true;
      const tick = () => {
        if (paused || !visible || document.hidden) return;
        const atEnd = pos() >= track.scrollWidth - track.clientWidth - 4;
        goTo(atEnd ? 0 : (index() + 1) % slides.length);
      };
      const start = () => { clearInterval(timer); timer = setInterval(tick, 5500); };
      ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((ev) => root.addEventListener(ev, () => { paused = true; }, { passive: true }));
      root.addEventListener('mouseleave', () => { paused = false; });
      new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(root);
      start();
    }
  });

  /* ---------- banner cards: active card + arrows ---------- */
  $$('[data-cards]').forEach((root) => {
    const track = $('[data-track]', root);
    const cards = [...track.children];
    if ('IntersectionObserver' in window) {
      root.classList.add('is-live');
      const ob = new IntersectionObserver((ents) => ents.forEach((en) => en.target.classList.toggle('is-active', en.intersectionRatio > 0.75)), { root: track, threshold: [0, 0.75, 1] });
      cards.forEach((c) => ob.observe(c));
    }
    const sec = root.closest('section');
    const by = (dir) => { const w = cards[0].offsetWidth + 14; track.scrollBy({ left: (rtl ? -dir : dir) * w, behavior: 'smooth' }); };
    sec && $('[data-next]', sec) && $('[data-next]', sec).addEventListener('click', () => by(1));
    sec && $('[data-prev]', sec) && $('[data-prev]', sec).addEventListener('click', () => by(-1));
  });

  /* ---------- product page: two offers flip ---------- */
  $$('[data-offers]').forEach((box) => {
    const faces = $$('[data-face]', box), tabs = $$('[data-offer-tab]', box);
    if (faces.length < 2) return;
    let i = 0, timer, paused = false;
    const ms = 4500;
    box.style.setProperty('--offer-ms', ms + 'ms');
    const show = (n) => {
      i = n % faces.length;
      faces.forEach((f, k) => { f.classList.toggle('is-on', k === i); f.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      tabs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => { if (!paused && !document.hidden) show(i + 1); }, ms); };
    tabs.forEach((t, k) => t.addEventListener('click', () => { show(k); start(); }));
    $('.offers__stage', box).addEventListener('click', () => { show(i + 1); start(); });
    box.addEventListener('mouseenter', () => { paused = true; box.classList.add('is-paused'); });
    box.addEventListener('mouseleave', () => { paused = false; box.classList.remove('is-paused'); });
    start();
  });

  /* ---------- announcement rotate ---------- */
  $$('[data-rotate]').forEach((r) => {
    const items = $$('.announce__item', r);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4000);
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const form = $('[data-pdp-form]', pdp);
    const qty = $('input[name=quantity]', pdp);
    $$('[data-step]', pdp).forEach((b) => b.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.step); }));

    // variants
    const vj = $('[data-variants]', pdp);
    if (vj) {
      const variants = JSON.parse(vj.textContent);
      const idInput = $('[data-variant-id]', pdp);
      const atc = $('[data-atc]', pdp);
      pdp.addEventListener('change', (e) => {
        if (!e.target.matches('[data-opt]')) return;
        const chosen = $$('fieldset.opt', pdp).map((fs) => ($('input:checked', fs) || {}).value);
        const v = variants.find((x) => x.options.every((o, k) => o === chosen[k]));
        if (!v) return;
        idInput.value = v.id;
        atc.disabled = !v.available;
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        fetch(`${location.pathname}?variant=${v.id}&section_id=${pdp.dataset.section}`).then((r) => r.text()).then((t) => {
          const doc = new DOMParser().parseFromString(t, 'text/html');
          const np = $('[data-price]', doc); const op = $('[data-price]', pdp);
          if (np && op) op.replaceWith(np);
        }).catch(() => {});
      });
    }

    // highlights clamp
    const hl = $('[data-clamp]', pdp); const hb = $('[data-clamp-btn]', pdp);
    if (hl && hb && hl.scrollHeight > 260) {
      hl.classList.add('is-clamped'); hb.hidden = false;
      hb.addEventListener('click', () => { hl.classList.remove('is-clamped'); hb.remove(); });
    }

    // sticky add to cart
    const sticky = $('[data-sticky-atc]');
    const atcBtn = $('[data-atc]', pdp);
    if (sticky && atcBtn) {
      sticky.hidden = false;
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        document.body.classList.toggle('has-sticky', show);
      }).observe(atcBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', (e) => addToCart(form, { btn: e.currentTarget }));
    }
  }

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach((el) => {
    if (el.children.length) return;
    new IntersectionObserver(([en], ob) => {
      if (!en.isIntersecting) return; ob.disconnect();
      fetch(el.dataset.url).then((r) => r.text()).then((t) => {
        const doc = new DOMParser().parseFromString(t, 'text/html');
        const s = $('[data-recs]', doc);
        if (s && s.innerHTML.trim()) { el.innerHTML = s.innerHTML; observeReveals(el); } else el.remove();
      }).catch(() => {});
    }, { rootMargin: '400px' }).observe(el);
  });

  /* ---------- predictive search ---------- */
  const pin = $('[data-predict]'); const pout = $('[data-predict-results]');
  if (pin && pout) {
    let t;
    pin.addEventListener('input', () => {
      clearTimeout(t);
      const q = pin.value.trim();
      if (q.length < 2) { pout.innerHTML = ''; return; }
      t = setTimeout(() => {
        fetch(`${TS.root.replace(/\/$/, '')}/search/suggest?q=${encodeURIComponent(q)}&resources%5Btype%5D=product&resources%5Blimit%5D=6&section_id=predictive-search`)
          .then((r) => r.text()).then((h) => { const d = new DOMParser().parseFromString(h, 'text/html'); const s = $('.shopify-section', d); pout.innerHTML = s ? s.innerHTML : ''; }).catch(() => {});
      }, 220);
    });
  }

  /* ---------- sort ---------- */
  const sort = $('[data-sort]');
  sort && sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });

  /* ---------- youtube facades ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-yt]');
    if (!b) return;
    const f = document.createElement('iframe');
    f.src = `https://www.youtube-nocookie.com/embed/${b.dataset.yt}?autoplay=1&playsinline=1&rel=0`;
    f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = 'YouTube';
    b.replaceWith(f);
  });

  /* ---------- reading bar ---------- */
  const rb = $('[data-readbar]'); const art = $('[data-article]');
  if (rb && art) {
    let r;
    addEventListener('scroll', () => { cancelAnimationFrame(r); r = requestAnimationFrame(() => {
      const b = art.getBoundingClientRect(); const p = Math.min(1, Math.max(0, (innerHeight - b.top) / (b.height + innerHeight * 0.3)));
      rb.style.transform = `scaleX(${p})`;
    }); }, { passive: true });
  }

  /* ---------- motion: auto reveal + stagger + word rise (fail-safe) ---------- */
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const AUTO = '.bcards, .shead, .coll-head, .crumbs, .pills, .coll-bar, .card, .tile, .quote, .stock__item, .faq .acc, .post, .ccard, .contact__form, .banner, .short, .pdp__media, .pdp__info > *, .ftr__brand, .ftr__col, .ftr__bottom, .cartp .line, .marquee, .search-page, .sec--top > .wrap > .h1, .sec--top .wrap--narrow > .rte, .article__img, .cartd__empty';
  const SPLIT = '.shead .h2, .coll-head .h1, .pdp__title, .sec--top > .wrap > .h1, .sec--top > .wrap--narrow > .h1';
  const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;');
  const splitWords = (el) => {
    if (el.dataset.split) return;
    const txt = el.textContent.trim().replace(/\s+/g, ' ');
    if (!txt || el.children.length > 1) return;
    el.dataset.split = '1';
    el.setAttribute('aria-label', txt);
    el.innerHTML = txt.split(' ').map((w, i) => `<span class="w" aria-hidden="true"><span style="--i:${i}">${esc(w)}</span></span>`).join(' ');
  };
  const tag = (scope = document) => {
    $$(AUTO, scope).forEach((el) => {
      if (el.closest('[data-drawer]') || el.classList.contains('reveal')) return;
      el.classList.add('reveal');
    });
    // stagger siblings
    const groups = new Map();
    $$('.reveal:not(.is-in)', scope).forEach((el) => {
      const p = el.parentElement; const n = groups.get(p) || 0; groups.set(p, n + 1);
      el.style.setProperty('--d', n % 6);
    });
    if (!reduce) $$(SPLIT, scope).forEach(splitWords);
  };
  let io;
  function observeReveals(scope = document) {
    tag(scope);
    const els = $$('.reveal:not(.is-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    if (!io) io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' });
    els.forEach((e) => io.observe(e));
  }
  document.documentElement.classList.add('reveal-ready');
  observeReveals();
  const revealVisible = () => $$('.reveal:not(.is-in)').forEach((e) => { const r = e.getBoundingClientRect(); if (r.top < innerHeight * 1.1) e.classList.add('is-in'); });
  setTimeout(revealVisible, 2500);
  let rv; addEventListener('scroll', () => { clearTimeout(rv); rv = setTimeout(revealVisible, 140); }, { passive: true });

  /* ---------- desktop mega menu: dim page, close on Esc ---------- */
  $$('.has-mega').forEach((li) => {
    let t;
    li.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => document.body.classList.add('mega-open'), 120); });
    li.addEventListener('mouseleave', () => { clearTimeout(t); document.body.classList.remove('mega-open'); });
    li.addEventListener('focusin', () => document.body.classList.add('mega-open'));
    li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) document.body.classList.remove('mega-open'); });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && document.activeElement && document.activeElement.closest('.has-mega')) { document.activeElement.blur(); document.body.classList.remove('mega-open'); } });

  /* ---------- header state ---------- */
  const hdr = $('[data-header]');
  if (hdr) {
    let hr; const onS = () => { cancelAnimationFrame(hr); hr = requestAnimationFrame(() => hdr.classList.toggle('is-scrolled', scrollY > 12)); };
    addEventListener('scroll', onS, { passive: true }); onS();
  }

  // cart page: open drawer instead of navigating when JS is on
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });
})();
